import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

export interface CKTextFieldProps {
  className?: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  readOnly?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isDisabled?: React.InputHTMLAttributes<HTMLTextAreaElement>['disabled'];
  isRequired?: React.InputHTMLAttributes<HTMLTextAreaElement>['required'];
  isReadOnly?: React.InputHTMLAttributes<HTMLTextAreaElement>['readOnly'];
  isSmall?: boolean;
  'aria-label'?: React.AriaAttributes['aria-label'];
  'aria-describedby'?: React.AriaAttributes['aria-describedby'];
  name?: string;
  id?: string;
}

const CKMultilineTextField: FunctionComponent<CKTextFieldProps> = ({
  className,
  id,
  onChange,
  isReadOnly,
  isDisabled,
  isRequired,
  isSmall,
  placeholder,
  value,
  name,
  ...rest
}) => {
  const inputClass = classNames('ck-field-multiline', className);

  return (
    <textarea
      id={id}
      onChange={onChange}
      readOnly={isReadOnly}
      disabled={isDisabled}
      required={isRequired}
      placeholder={placeholder}
      name={name}
      value={value}
      className={inputClass}
      {...rest}
    />
  );
};

export default CKMultilineTextField;
